/**
 * Number of policies expired, by four Underwriting/ Re-underwriting results, by whether the Insured Person is newly insured or isured through Migration
 */

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[1].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 4 }
		},
		{
			s: { r: 1, c: 5 },
			e: { r: 1, c: 8 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template A6 - Number of policies expired, by four Underwriting/ Re-underwriting results, by whether the Insured Person is newly insured or isured through Migration"
	],
	["Status", "Standard Plan", "", "", "", "Flexi Plan", "", "", ""],
	[
		"",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE"
	]
]

const rows = payload => [
	[
		"1. Newly insured (those not falling under status 2-4 in the following rows)",
		"",
		"",
		"",
		""
	],
	["2. Insured through Migration (through renewal)", "", "", "", ""],
	[
		"3. Insured through Migration (new plan without Re-underwriting)",
		"",
		"",
		"",
		""
	],
	[
		"4. Insured through Migration (new plan with Re-underwriting)",
		"",
		"",
		"",
		""
	]
]
